(function () {
  'use strict';
  function safeUrl(value) {
    try { var url = new URL(value, window.location.origin); return /^https?:$/.test(url.protocol) ? url.href : null; } catch (_) { return null; }
  }
  function setup(root) {
    if (root.dataset.nslReady) return;
    root.dataset.nslReady = 'true';
    var cleanups = [];
    function listen(el, event, callback, options) { if (!el) return; el.addEventListener(event, callback, options); cleanups.push(function () { el.removeEventListener(event, callback, options); }); }
    // Mirrors the planner: six hours from the first visit, shared by both offer rows.
    var saleRows = Array.from(root.querySelectorAll('[data-nsl-sale-row]'));
    var saleTimers = Array.from(root.querySelectorAll('[data-nsl-sale-timer]'));
    var countdownEnd = NaN;
    var countdownInterval = null;
    if (root.dataset.nslCountdownEnabled === 'true' && saleTimers.length) {
      countdownEnd = Date.now() + 6 * 60 * 60 * 1000;
      try {
        var storedEnd = Number(window.localStorage.getItem(root.dataset.nslCountdownKey));
        if (Number.isFinite(storedEnd) && storedEnd > 0) countdownEnd = storedEnd;
        else window.localStorage.setItem(root.dataset.nslCountdownKey, String(countdownEnd));
      } catch (_) {
        // Keep the counter usable when the browser blocks local storage.
      }
    }
    function updateCountdown() {
      var seconds = Math.ceil((countdownEnd - Date.now()) / 1000);
      var showTimer = Number.isFinite(seconds) && seconds > 0;
      saleRows.forEach(function (row) { row.hidden = Number(row.dataset.discount) <= 0 && !showTimer; });
      saleTimers.forEach(function (timer) {
        timer.hidden = !showTimer;
        var row = timer.closest('[data-nsl-sale-row]');
        timer.querySelector('[data-nsl-sale-separator]').hidden = Number(row.dataset.discount) <= 0;
        if (!showTimer) return;
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor(seconds % 86400 / 3600);
        var minutes = Math.floor(seconds % 3600 / 60);
        var remainder = seconds % 60;
        var time = timer.querySelector('[data-nsl-countdown]');
        time.textContent = (days ? days + 'd ' : '') + hours + ':' + String(minutes).padStart(2, '0') + ':' + String(remainder).padStart(2, '0');
        time.setAttribute('aria-label', days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, ' + remainder + ' seconds remaining');
      });
      if (!showTimer && countdownInterval !== null) { clearInterval(countdownInterval); countdownInterval = null; }
    }
    updateCountdown();
    if (Number.isFinite(countdownEnd) && countdownEnd > Date.now()) {
      countdownInterval = setInterval(updateCountdown, 1000);
      cleanups.push(function () { clearInterval(countdownInterval); });
    }
    var dialog = root.querySelector('[data-nsl-dialog]');
    var dialogImg = root.querySelector('[data-nsl-dialog-image]');
    var opener = null;
    var oldOverflow = '';
    function openPreview(link, event) {
      if (!dialog || !dialog.showModal || event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
      var src = safeUrl(link.href); if (!src) return;
      if (event) event.preventDefault();
      opener = link;
      root.querySelector('[data-nsl-dialog-title]').textContent = link.dataset.label || 'Reader photo';
      dialogImg.src = src; dialogImg.alt = link.dataset.label || 'Reader photo';
      root.querySelector('[data-nsl-dialog-original]').href = src;
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
    listen(root, 'click', function (event) {
      var link = event.target.closest('[data-nsl-preview]');
      if (link && root.contains(link)) openPreview(link, event);
    });
    listen(root.querySelector('[data-nsl-dialog-close]'), 'click', function () { dialog.close(); });
    listen(dialog, 'click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    listen(dialog, 'close', function () { document.documentElement.style.overflow = oldOverflow; if (opener && opener.isConnected) opener.focus({ preventScroll: true }); });

    var tabs = Array.from(root.querySelectorAll('[data-nsl-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-nsl-panel]'));
    function selectTab(index, focus) {
      tabs.forEach(function (tab, i) { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      panels.forEach(function (panel, i) { panel.hidden = i !== index; });
      if (focus) tabs[index].focus();
    }
    tabs.forEach(function (tab, index) {
      listen(tab, 'click', function () { selectTab(index, false); });
      listen(tab, 'keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); selectTab(next, true);
      });
    });
    // A useful preview remains visible when JavaScript is unavailable; anchors open originals.
    var localPhotos = {};
    try { localPhotos = JSON.parse(root.getAttribute('data-photo-assets') || '{}'); } catch (_) {}
    var reviews = [];
    try { reviews = JSON.parse(root.getAttribute('data-reviews') || '[]'); } catch (_) {}
    if (!Array.isArray(reviews)) reviews = [];
    reviews = reviews.filter(function (review) { return review && typeof review === 'object' && typeof review.body === 'string' && review.body.trim(); });
    var used = new Set();
    reviews = reviews.filter(function (review) { var key = String(review.author) + '\n' + review.body; if (used.has(key)) return false; used.add(key); return true; });
    var summary = root.querySelector('[data-nsl-review-summary]');
    if (summary && reviews.length) summary.textContent = reviews.length + ' reader reviews';
    if (!reviews.length) { root.querySelector('[data-nsl-review-section]').hidden = true; if (summary) summary.closest('a').hidden = true; }
    function createReview(review) {
      var card = document.createElement('article'); card.className = 'nsl-review';
      var rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      if (rating) { var stars = document.createElement('span'); stars.className = 'nsl-stars'; stars.textContent = '★★★★★'.slice(0, rating); stars.setAttribute('aria-label', rating + ' out of 5 stars'); card.append(stars); }
      var body = document.createElement('p'); body.className = 'nsl-review-body';
      if (review.body.length > 270) {
        var cut = review.body.lastIndexOf(' ', 210); body.textContent = review.body.slice(0, cut > 0 ? cut : 210) + '…'; card.append(body);
        var details = document.createElement('details'); var detailsLabel = document.createElement('summary'); detailsLabel.textContent = 'Read full review';
        var full = document.createElement('p'); full.textContent = review.body; details.append(detailsLabel, full); card.append(details);
      } else { body.textContent = review.body; card.append(body); }
      var who = document.createElement('div'); who.className = 'nsl-review-author'; who.textContent = review.author || 'Reader';
      if (review.verified_purchase === true || review.verified_purchase === 'true') { var badge = document.createElement('span'); badge.className = 'nsl-verified'; badge.textContent = 'Verified buyer'; who.append(badge); }
      // Show a job only when the supplied review actually includes one.
      if (typeof review.job === 'string' && review.job.trim()) { var job = document.createElement('span'); job.className = 'nsl-small'; job.textContent = review.job; who.append(job); }
      card.append(who);
      var photos = Array.isArray(review.pictures_urls) ? review.pictures_urls : [];
      if (photos.length) {
        var row = document.createElement('div'); row.className = 'nsl-review-photos';
        photos.slice(0, 3).forEach(function (photo, i) {
          var src = safeUrl(localPhotos[photo] || photo); if (!src) return;
          var link = document.createElement('a'); link.href = src; link.target = '_blank'; link.rel = 'noopener'; link.dataset.nslPreview = ''; link.dataset.label = (review.author || 'Reader') + ' · reader photo ' + (i + 1); link.setAttribute('aria-label', 'Open ' + link.dataset.label);
          var img = document.createElement('img'); img.src = src; img.alt = 'Photo supplied with ' + (review.author || 'a reader') + '’s review'; img.loading = 'lazy'; img.width = 150; img.height = 150;
          img.addEventListener('error', function () { link.remove(); }); link.append(img); row.append(link);
        });
        card.append(row);
      }
      return card;
    }
    var primary = root.querySelector('[data-nsl-reviews]'); var extra = root.querySelector('[data-nsl-extra-reviews]');
    reviews.forEach(function (review, i) { (i < 3 ? primary : extra).append(createReview(review)); });
    if (reviews.length > 3) { root.querySelector('[data-nsl-more-reviews]').hidden = false; root.querySelector('[data-nsl-more-label]').textContent = 'Read ' + (reviews.length - 3) + ' more reader reviews'; }
    var spotlight = root.querySelector('[data-nsl-spotlight]');
    if (reviews.length && spotlight) {
      var featured = reviews.find(function (review) { return review.author === 'Fin'; }) || reviews[0];
      var sentence = featured.body.match(/^.*?[.!?](?:\s|$)/);
      root.querySelector('[data-nsl-spotlight-text]').textContent = '“' + (sentence ? sentence[0].trim() : featured.body.slice(0, 180)) + '”';
      root.querySelector('[data-nsl-spotlight-author]').textContent = '— ' + (featured.author || 'Reader'); spotlight.hidden = false;
    }
    var sticky = root.querySelector('[data-nsl-sticky]'); var hero = root.querySelector('[data-nsl-hero-purchase]');
    var stops = Array.from(root.querySelectorAll('[data-nsl-sticky-stop]'));
    var frame = null;
    function updateSticky() {
      frame = null; if (!sticky) return;
      var passed = hero.getBoundingClientRect().bottom < 0;
      var stop = stops.some(function (node) { var r = node.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; });
      sticky.hidden = !passed || stop || dialog && dialog.open;
    }
    function scheduleSticky() { if (frame === null) frame = requestAnimationFrame(updateSticky); }
    listen(window, 'scroll', scheduleSticky, { passive: true }); listen(window, 'resize', scheduleSticky); listen(dialog, 'close', scheduleSticky); listen(root, 'click', scheduleSticky); updateSticky();
    // Set this variant to quantity one; preserve every other item in the shopper's cart.
    // Native form submission remains available if fetch is unsupported or scripts do not run.
    var busy = false;
    var forms = Array.from(root.querySelectorAll('[data-nsl-buy-form]'));
    forms.forEach(function (form) {
      listen(form, 'submit', async function (event) {
        if (!window.fetch || !window.AbortController) return;
        event.preventDefault(); if (busy) return;
        var variant = form.dataset.variant; if (!/^\d+$/.test(variant || '')) return;
        busy = true;
        var snapshots = forms.map(function (f) { var button = f.querySelector('button'); var label = f.querySelector('[data-nsl-button-text]'); var state = { button: button, label: label, text: label.textContent, disabled: button.disabled }; button.disabled = true; f.setAttribute('aria-busy', 'true'); f.querySelector('.nsl-form-error').hidden = true; return state; });
        form.querySelector('[data-nsl-button-text]').textContent = 'Opening checkout…';
        var controller = new AbortController(); var timeout = setTimeout(function () { controller.abort(); }, 15000);
        try {
          var updates = {}; updates[variant] = 1;
          var response = await fetch(root.dataset.cartUpdate, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }), signal: controller.signal });
          if (!response.ok) throw new Error('Cart update failed');
          var cart = await response.json();
          if (!cart || !Array.isArray(cart.items) || !cart.items.some(function (item) { return String(item.variant_id || item.id) === variant && item.quantity >= 1; })) throw new Error('Item missing');
          clearTimeout(timeout); window.location.assign(root.dataset.checkout);
        } catch (_) {
          clearTimeout(timeout); busy = false;
          snapshots.forEach(function (state) { state.button.disabled = state.disabled; state.label.textContent = state.text; state.button.closest('form').removeAttribute('aria-busy'); });
          var error = form.querySelector('.nsl-form-error'); error.textContent = 'Couldn’t open checkout. Please try again.'; error.hidden = false;
        }
      });
    });
    root.nslCleanup = function () { cleanups.forEach(function (fn) { fn(); }); if (frame !== null) cancelAnimationFrame(frame); if (dialog && dialog.open) dialog.close(); };
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-nsl-root]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-nsl-root]').forEach(function (root) { if (root.nslCleanup) root.nslCleanup(); }); });
})();
